import React, {useEffect, useState} from 'react';
import { Modal, Button, Form, Row, Col, Card, Table, Badge, Dropdown, Pagination,  } from 'react-bootstrap';
import {useNavigate} from "react-router-dom";
import FormControl from "../../../shared/components/FormControl";
import {businessYearService} from "../../../services/businessYearService";
import eventEmitter from "../../../shared/eventEmitter";
import {EventEmitterTypes} from "../../../shared/eventEmitterEnum";
import notificationService from "../../../services/NotificationService";
import NotificationService from "../../../services/NotificationService";
import {listService} from "../../../services/listsService";

interface NewYearSetupProps {
    show: boolean;
    toggle: () => void;
}


const NewYearSetupModal: React.FC<NewYearSetupProps> = ({show, toggle}) => {
    const [currentYear, setCurrentYear] = useState(2025);

    function handleSubmit() {
        businessYearService.createNewYear(currentYear+1).then(r => {
            eventEmitter.emit(EventEmitterTypes.REFRESH_YEARLY_SETTINGS)
            toggle();
        })
    }

    useEffect(() => {
        (async () => {
            const businessYearsRes = await businessYearService.getBusinessYears();
            const currentYear = businessYearsRes.filter(x => x.current)[0];
            setCurrentYear(currentYear.year);
        })();
    }, []);
    
    return (
        <Modal show={show} onHide={toggle}>
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-body text-center">
				<span className="text-light icon mb-3">
                    <i className="fa-solid fa-square-question"></i>
                </span>
                        <p className="mb-4">
                            Are you sure you want to setup for {currentYear + 1}?
                        </p>
                        <div className="mb-2">
                            <button onClick={handleSubmit} type="button" className="btn btn-primary text-strong text-uppercase m-100">Yes,
                                setup {currentYear + 1}
                            </button>
                        </div>
                        <div className="pb-2">
                            <a onClick={toggle} role="button" className="m-100 text-muted" data-bs-dismiss="modal">Nevermind</a>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default NewYearSetupModal;
